<span class="order-confirm-label">
    <span>{{ label() }}</span>
    <mat-icon matTooltip="This is availble only if order in status Fraud Held" svgIcon="ico_info"></mat-icon>
</span>
<button mat-raised-button [disabled]="disabled()" (click)="confirm()">
    Confirm
    @if (isLoading()) {
        <mat-icon class="loading">hourglass_empty</mat-icon>
    }
</button>
<button mat-raised-button [disabled]="disabled()" (click)="decline()">
    Decline
    @if (isLoading()) {
        <mat-icon class="loading">hourglass_empty</mat-icon>
    }
</button>
